import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
  ) { }

  authenticate(data: string): Observable<any> {
    const apiUrl = environment.apiAuthenticate + 'a';
    return this.http.post(apiUrl, { data });
  }
  
  setAuthToken(token: string): void {
    localStorage.setItem('accessToken', token);
  }

  getAuthToken(): string | null {
    return localStorage.getItem('accessToken');
  }

  clearAuthToken(): void {
    localStorage.removeItem('accessToken');
  }

}
